import { render, staticRenderFns } from "./RRFL.vue?vue&type=template&id=fefba0d0&scoped=true&"
import script from "./RRFL.vue?vue&type=script&lang=js&"
export * from "./RRFL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefba0d0",
  null
  
)

export default component.exports